package com.xtream.ui.ui.widget

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusEvent
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.LifecycleResumeEffect


@Composable
fun LazyContentRow(
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(horizontal = 16.dp),
    headerTitle: String?=null,
    actionTitle: String?=null,
    onActionClick:(()->Unit)?=null,
    state: LazyListState = rememberLazyListState(),
    content: LazyListScope.() -> Unit){

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = contentPadding.calculateStartPadding(LayoutDirection.Ltr))
            .padding(bottom = 8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = headerTitle ?: "",
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier.weight(1f)
        )

        if (actionTitle != null)
            Text(
                text = actionTitle,
                style = MaterialTheme.typography.titleSmall,
                color = MaterialTheme.colorScheme.primary,
                modifier = Modifier
                    .clickable { onActionClick?.invoke() }
                    .fillMaxHeight()
//                .background(MaterialTheme.colorScheme.primary.copy(alpha = .07f) , MaterialTheme.shapes.small)
                    //.padding(horizontal = 8.dp)
                    .clip(MaterialTheme.shapes.small)
            )
    }
    LazyRow(
        state = state,
        contentPadding = contentPadding,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = modifier
            .padding(bottom = 16.dp)
            .fillMaxWidth()
        //.background(Color.White.copy(alpha = .8f))
        ,
        content = content
    )



}

@Composable
fun LazyContentRow(
    modifier: Modifier = Modifier,
    focusRequester: FocusRequester = FocusRequester.Default,
    focusRestorer: FocusRequester = FocusRequester.Default, // plain, not lambda
    contentPadding: PaddingValues = PaddingValues(horizontal = 16.dp),
    title: String? = null,
    actionTitle: String? = null,
    onActionClick: (() -> Unit)? = null,
    state: LazyListState = rememberLazyListState(),
    content: LazyListScope.() -> Unit
) {
    var hasFocus by rememberSaveable { mutableStateOf(false) }
    val useAlpha =false
    //isDpadNavigation()
    //adaptiveValue(expandedValue = true, compactValue = false, default = false)
    val animatedAlpha by animateFloatAsState(
        targetValue = if (hasFocus || !useAlpha) 1f else 0.3f,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy, // bounciness
            stiffness = Spring.StiffnessMedium              // speed
        ),
        label = "focus_alpha"
    )

    Column(


        modifier = Modifier.graphicsLayer {
            alpha = animatedAlpha
        }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = contentPadding.calculateStartPadding(LayoutDirection.Ltr))
                .padding(bottom = 12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(text = title ?: "", style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
            if (actionTitle != null) {
                Text(
                    text = actionTitle,
                    style = MaterialTheme.typography.titleSmall,
                    color = MaterialTheme.colorScheme.primary,
                    modifier = Modifier.clickable { onActionClick?.invoke() }.clip(MaterialTheme.shapes.small)
                )
            }
        }

        LazyRow(
            state = state,
            contentPadding = contentPadding,
            horizontalArrangement = Arrangement.spacedBy(14.dp),
            modifier = modifier
                .padding(bottom = 16.dp)
                .fillMaxWidth()
                .onFocusEvent { hasFocus = it.hasFocus }
                .focusRequester(focusRequester)
                .focusRestorer(focusRestorer),
            content = content
        )
    }

    // ✅ Fires on recomposition entry after lazy disposal
    //    restoreFocusedChild() fails (node gone) → requestFocus() triggers
    //    focusRestorer which targets the correct item via the resolved requester
    LaunchedEffect(Unit) {
        if (hasFocus) {
            //   val restored =
            focusRequester.restoreFocusedChild()
            // if (!restored) focusRequester.requestFocus()
        }
    }

    // Handles Activity/Fragment resume only
    LifecycleResumeEffect(Unit) {
        //if (hasFocus) focusRequester.restoreFocusedChild()
        onPauseOrDispose {
            if (hasFocus) focusRequester.saveFocusedChild()
        }
    }
}
